export default {
    lang: {
        name: 'Published year'
    }
}